import { render, staticRenderFns } from "./isomere-alkohole.vue?vue&type=template&id=2ef83f1c&"
import script from "./isomere-alkohole.vue?vue&type=script&lang=js&"
export * from "./isomere-alkohole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports